import BaseService from './BaseService'
import entities from 'src/config/entities'

class SiteAdminService extends BaseService {

  constructor () {
    super({entity: entities.ADMIN})
  }
}

export default new SiteAdminService()
